import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef, OnChanges, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { AnnouncementHttpService } from '@core/services/announcement-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PPChallengePromotionHttpService } from '@core/services/pp-challenge-promotion-http.service';
import { BTGChallengePromotionHttpService } from '@core/services/btg-challenge-promotion-http.service';
@Component({
  selector: 'app-promotion-dialog',
  templateUrl: './promotion-dialog.component.html',
  styleUrls: ['./promotion-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromotionDialogComponent implements OnInit {

  content$ = [];
  displayStyle = "block";
  target = '_blank';

  isLoggedIn$: Observable<boolean>;
  promoPP = JSON.parse(localStorage.getItem('activePPChallengePromo') || '{}');
  promoBTG = JSON.parse(localStorage.getItem('activeBTGChallengePromo') || '{}');
  userData = JSON.parse(localStorage.getItem('user_data') || '{}');
  
  constructor(
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PromotionDialogComponent>,
    private ppChallengePromotionHttpService: PPChallengePromotionHttpService,
    private btgChallengePromotionHttpService: BTGChallengePromotionHttpService,
    private eventEmitterService: EventEmitterService,
    @Inject(MAT_DIALOG_DATA) public data: { PPPhase1?: boolean, gameProvider?: any, Phase1WinLose?: number, memberPromotionID?: number, p1AccumulatedAmount?: number, PPPhase2?: boolean, BTGPhase1?: boolean, BTGPhase2?: boolean },
  ) { }

  @Input()
  message: any[];

  @Output()
  confirmed = new EventEmitter<boolean>();

  ngOnInit() {
  }

  closePopup() {
    this.dialogRef.close();
    
    if (this.promoPP && Object.keys(this.promoPP).length > 0) {
      const data = {
        member_promotion_id: this.promoPP.p2MemberPromotionID,
        p2Dialog: 1
      };

      this.ppChallengePromotionHttpService.updatePPChallengeDialogSeen(data).subscribe(() => {
        this.promoPP.p2PopSeen = true;
        localStorage.setItem('activePPChallengePromo', JSON.stringify(this.promoPP));
      });
    } else if (this.promoBTG && Object.keys(this.promoBTG).length > 0) {
      const data = {
        member_promotion_id: this.promoBTG.p2MemberPromotionID,
        p2Dialog: 1
      };

      this.btgChallengePromotionHttpService.updateBTGChallengeDialogSeen(data).subscribe(() => {
        this.promoBTG.p2PopSeen = true;
        localStorage.setItem('activeBTGChallengePromo', JSON.stringify(this.promoBTG)); 
      });
    }

  }

  proceedToP2(toP2: boolean) {
    this.dialogRef.close();
    
    if (this.promoPP && Object.keys(this.promoPP).length > 0) {
      const data = {
        member_promotion_id: this.data.memberPromotionID ? this.data.memberPromotionID : this.promoPP.p1MemberPromotionID,
        p1ResultDialog: 1
      };

      this.ppChallengePromotionHttpService.updatePPChallengeDialogSeen(data).subscribe(() => {
        this.promoPP.p1ResPopSeen = true;
        localStorage.setItem('activePPChallengePromo', JSON.stringify(this.promoPP));

        let slotSession = sessionStorage.getItem('slotSession') === null ? {} : JSON.parse(sessionStorage.getItem('slotSession'));

        if (Object.keys(slotSession).length !== 0 && slotSession[data['PP']] && Object.keys(slotSession[data['PP']]).length !== 0) {
          slotSession[data['PP']] = {};
          sessionStorage.setItem('slotSession', JSON.stringify(slotSession));
        }

        const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
        const redirectUsers = JSON.parse(localStorage.getItem('whitelist_game_launch') || '{}');;
        const username = userData?.username;
        const iframeProviders = JSON.parse(localStorage.getItem('whitelist_game_provider') || '{}');
        const currentGame = localStorage.getItem('gameProviderCode') || null;
        const gameProviderLaunch = sessionStorage.getItem('game_provider_launch');

        if (toP2 == true) {
          this.promoPP.startPhase2 = true;
          this.promoPP.p2PopSeen = false;

          localStorage.setItem('activePPChallengePromo', JSON.stringify(this.promoPP));

          if (username && (redirectUsers.includes(username) || iframeProviders.includes(currentGame)) && gameProviderLaunch == 'PP') {
            if (this.router.url === '/launch-game') {
              this.eventEmitterService.onPPReloadIframeEmitter();

              this.dialog.open(PromotionDialogComponent, {
                width: 'auto',
                data: { PPPhase2: true } 
              });
            }
          } else {
            if (this.router.url === '/slots-game/pragmaticplay') {
              this.eventEmitterService.onUpdateGameListEmitter();
            } else {
              this.router.navigate(['/slots-game/pragmaticplay']);
            }
          }
        } else {
          if (username && redirectUsers.includes(username) && gameProviderLaunch == 'PP') {
            if (this.router.url === '/launch-game') {
              this.eventEmitterService.onPPReloadIframeEmitter();
            }
          } else if (this.router.url === '/slots-game/pragmaticplay') {
            this.eventEmitterService.onUpdateGameListEmitter();
          }
        }
      });
    } else if (this.promoBTG && Object.keys(this.promoBTG).length > 0) {
      const data = {
        member_promotion_id: this.data.memberPromotionID ? this.data.memberPromotionID : this.promoBTG.p1MemberPromotionID,
        p1ResultDialog: 1
      };

      this.btgChallengePromotionHttpService.updateBTGChallengeDialogSeen(data).subscribe(() => {
        this.promoBTG.p1ResPopSeen = true;
        localStorage.setItem('activeBTGChallengePromo', JSON.stringify(this.promoBTG));
        if (toP2 == true) {
          this.promoBTG.startPhase2 = true;
          this.promoBTG.p2PopSeen = false;

          localStorage.setItem('activeBTGChallengePromo', JSON.stringify(this.promoBTG));
          
          if (this.router.url === '/slots-game/btgaming') {
            this.eventEmitterService.onUpdateGameListEmitter();
          } else {
            this.router.navigate(['/slots-game/btgaming']);
          }
        } else {
          if (this.router.url === '/slots-game/btgaming') {
            this.eventEmitterService.onUpdateGameListEmitter();
          }
        }
      });
    }
  }

  launchGame() {
    if (this.promoPP && Object.keys(this.promoPP).length > 0) {
      const data = {
        promotion_id: this.promoPP.p1PromotionID,
        p1Dialog: 1
      };
      
      this.ppChallengePromotionHttpService.updatePPChallengeDialogSeen(data).subscribe(() => {
        this.promoPP.p1PopSeen = true;
        localStorage.setItem('activePPChallengePromo', JSON.stringify(this.promoPP));
      });
    } else if (this.promoBTG && Object.keys(this.promoBTG).length > 0) {
      const data = {
        promotion_id: this.promoBTG.p1PromotionID,
        p1Dialog: 1
      };

      this.btgChallengePromotionHttpService.updateBTGChallengeDialogSeen(data).subscribe(() => {
        this.promoBTG.p1PopSeen = true;
        localStorage.setItem('activeBTGChallengePromo', JSON.stringify(this.promoBTG));
      });
    }

    window.history.replaceState({}, '', `/slots-game/${this.data.gameProvider.game_provider_name.replace(/\s/g, '').toLowerCase()}`);

    localStorage.setItem('gameProviderCode', this.data.gameProvider.game_provider_code);
    localStorage.setItem('gameProviderId', this.data.gameProvider.game_provider_id);
    localStorage.setItem('gameCode', this.data.gameProvider.code);
    localStorage.setItem('gameCategory', 'SL');
    localStorage.setItem('gameType', 'undefined');
    localStorage.setItem('isPlayTechClicked', 'false');
    localStorage.setItem('lobbyUrl', location.href);
    localStorage.setItem('gameMode', 'real');
    localStorage.setItem('gameDemo', '0');

    const userData = JSON.parse(localStorage.getItem('user_data') || '{}');
    const redirectUsers = JSON.parse(localStorage.getItem('whitelist_game_launch') || '{}');;
    const username = userData?.username;
    const iframeProviders = JSON.parse(localStorage.getItem('whitelist_game_provider') || '{}');
    const currentGame = localStorage.getItem('gameProviderCode') || null;

    sessionStorage.setItem('game_provider_launch', this.data.gameProvider.game_provider_code);

    // Define the users who should be redirected
    if (username && (redirectUsers.includes(username) || iframeProviders.includes(currentGame))) {
      this.router.navigate([]).then(() => { window.open('/gamelaunch', '_self', this.target); });
    }
    else {
      this.router.navigate([]).then(() => { window.open('/gamelaunch', this.target); });
    }

    this.dialogRef.close();
  }
}
